export const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export function parseBRValue(value: string): number {
  if (value.includes(',')) {
    return parseFloat(value.replace(/\./g, '').replace(',', '.'));
  }
  return parseFloat(value);
}

export function formatCurrency(value: number): string {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

export function getMonthFromVencimento(vencimento: string): string {
  const parts = vencimento.split('/');
  if (parts.length < 2) {
    return vencimento;
  }
  const index = parseInt(parts[1], 10) - 1;
  return MONTHS[index] ?? vencimento;
}

export function getVencimentoStatus(
  vencimento: string,
): 'Vencido' | 'A vencer' {
  const [day, month, year] = vencimento.split('/').map(Number);
  const vencDate = new Date(year, month - 1, day);
  return vencDate < new Date() ? 'Vencido' : 'A vencer';
}